import { Form, Modal, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import InputNumberComponent from 'components/atoms/InputNumberComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import { IKoducastnika, ueKoducastnika } from 'services/specialniSluzby/ueKoducastnika';
import { IZalozeniPostId } from 'services/specialniSluzby/ueZalozeni';
import {
    IDataZalozeniPozadavekDVP,
    IPozadavkyDVP,
    IPozadavkyPolozkaDVP,
    ueZalozeniPozadavekDVP
} from 'services/specialniSluzby/uevDVP';

import { ETypPozadavku } from 'enums/specialniSluzby/typPozadavku';

import dveDesetinneMistaValidation from 'utils/validations/dveDesetinneMistaValidation';
import numberValidation from 'utils/validations/numberValidation';

interface INovyPozadavekDVP {
    setZmenaPozadavku: (value: 'edit' | 'novy' | undefined) => void;
    setSelectedDetail: React.Dispatch<React.SetStateAction<IPozadavkyPolozkaDVP | undefined>>;
    zmenaPozadavku?: 'edit' | 'novy';
    data?: IPozadavkyDVP;
    detailData?: IPozadavkyPolozkaDVP;
}

const NovyPozadavekDVP: React.FC<INovyPozadavekDVP> = ({
    setZmenaPozadavku,
    data,
    zmenaPozadavku,
    detailData,
    setSelectedDetail
}) => {
    const { specialniSluzby, cisMeny } = useContext(Context);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const [modalResp, setModalResp] = useState<string>('');
    const [koducastnika, setKoducastnika] = useState<{ value: string; labelcz: string }[]>([]);
    const [, rerender] = useState<boolean>(false);

    useEffect(() => {
        setLoading(true);
        ueKoducastnika()
            .then((resp: IKoducastnika) => {
                const tmpSelectArr: { value: string; labelcz: string }[] = [];
                resp.kodyucastnika.forEach(item => {
                    (specialniSluzby?.detail?.typ !== ETypPozadavku.UPIS ? item.kod !== '100' : true) &&
                        tmpSelectArr.push({
                            value: item.kod,
                            labelcz: item.kod + ' - ' + item.nazev
                        });
                });
                setKoducastnika(tmpSelectArr);
            })
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LoadingWrapper loading={loading}>
            <FormWrapper
                onFinish={vals => {
                    setLoading(true);
                    ueZalozeniPozadavekDVP(specialniSluzby?.detail?.id || 0, {
                        ...vals,
                        ...(zmenaPozadavku === 'edit' && {
                            idpolozky: detailData?.idpolozky
                        })
                    } as IDataZalozeniPozadavekDVP)
                        .then((resp: IZalozeniPostId) => {
                            if (resp.sankce) setModalResp('SANKCE');
                            else if (resp.stav === 'OK') {
                                setZmenaPozadavku(undefined);
                                setSelectedDetail(undefined);
                            } else setModalResp(resp.stav);
                        })
                        .catch((err: any) => console.log('Zalozeni POSTid err', err))
                        .finally(() => setLoading(false));
                }}
                outForm={form}
            >
                <SelectComponent
                    isFormItem={true}
                    data={koducastnika || []}
                    name="koducastnika"
                    defaultValue={zmenaPozadavku === 'edit' ? detailData?.koducastnika : undefined}
                    labelParagraph={'KOD_UCASTNIKA'}
                />
                <InputComponent
                    name="kodklienta"
                    label="DVP_IDENTIFIKACE_KLIENTA"
                    initialValue={zmenaPozadavku === 'edit' ? detailData?.kodklienta : undefined}
                    maxLength={50}
                />
                <InputNumberComponent
                    name="pocetcp"
                    label="POCET_CP"
                    maxLength={12}
                    initialValue={zmenaPozadavku === 'edit' ? detailData?.pocetcp : undefined}
                    onChangeCustom={() => rerender(pv => !pv)}
                    rules={numberValidation(true)}
                />
                <InputNumberComponent
                    name="castka"
                    label="DVP_CELKOVA_CASTKA"
                    maxLength={12}
                    precision={2}
                    initialValue={zmenaPozadavku === 'edit' ? detailData?.castka : undefined}
                    rules={dveDesetinneMistaValidation(true)}
                />
                {data?.mena && (
                    <SelectComponent
                        hide={true}
                        name="mena"
                        labelParagraph="DODATEK_INVCERT_NAV_MENA"
                        isFormItem={true}
                        disabled={true}
                        data={cisMeny}
                        defaultValue={data?.mena}
                        notRequired={true}
                    />
                )}
                <Row className="button-row">
                    <ButtonComponent
                        id="zpetBtn"
                        buttontext="ZPET"
                        type="default"
                        onClick={() => setZmenaPozadavku(undefined)}
                    />
                    <ButtonComponent id="pridatPozadavkeSouborBtn" buttontext="ZAPSAT" htmlType="submit" />
                </Row>
                <Modal
                    title={<TranslateText>SS_NOVY_RUCNI_MODAL_ZAPIS</TranslateText>}
                    open={modalResp !== ''}
                    onCancel={() => setModalResp('')}
                    footer={[
                        <Row>
                            <ButtonComponent
                                buttontext="ZAVRIT"
                                onClick={() => {
                                    setModalResp('');
                                }}
                                id="zavritModalBtn"
                            />
                        </Row>
                    ]}
                >
                    <Row>
                        <Paragraph text={'SS_NOVY_RUCNI_MODAL_RESP_' + modalResp} />
                    </Row>
                </Modal>
            </FormWrapper>
        </LoadingWrapper>
    );
};

export default NovyPozadavekDVP;
